import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
// import { BaseRequest } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
// import { MockBackend } from '@angular/common/http/testing';

import { AuthRoutingModule } from './auth-routing.routing';

import { AuthComponent } from './auth.component';
import { AlertComponent } from './_directives/alert.component';
import { LogoutComponent } from './logout/logout.component';
import { ResetPassComponent } from './reset-pass/reset-pass.component';
import { VerifyUserComponent } from './verify-user/verify-user.component';
import { AuthGuard } from './_guards/auth.guard';
import { RoleGuard } from './_guards/role.guard';
import { CognitoService } from './cognito';
import { AlertService } from './_services/alert.service';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';

@NgModule({
    declarations: [
        AuthComponent,
        AlertComponent,
        ResetPassComponent,
        VerifyUserComponent,
        LogoutComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        HttpClientModule,
        AuthRoutingModule,
        SweetAlert2Module.forRoot()
    ],
    providers: [
        AuthGuard,
        RoleGuard,
        CognitoService,
        AlertService
        // api backend simulation
        // MockBackend,
        // BaseRequestOptions,
    ]
})

export class AuthModule {
}
